export default "__VITE_ASSET__6fd421b1__"